/* Happy Monkfruit — product page behaviour.
   Externalised from snippets/hmf-product-js.liquid so the browser can cache it
   once instead of re-parsing ~36 KB of inline script on every product view.
   All Liquid-derived values arrive through window.HMF_PDP_CFG, which the
   snippet still prints inline (a few hundred bytes). */
(function(){
  var CFG = window.HMF_PDP_CFG;
  if(!CFG) return;

  var ROOT = document.getElementById('hmf-pdp-' + CFG.sid);
  if(!ROOT || ROOT.dataset.hmfInit) return;
  ROOT.dataset.hmfInit = '1';

  // Pre-resolved asset URLs (avoid string surgery on CDN params)
  var ASSETS = CFG.assets || {};
  function url(f){ return ASSETS[f] || f; }
  // Shopify's CDN resizes on the fly via &width= (asset_url already carries ?v=)
  // and negotiates WebP/AVIF from the browser's Accept header on its own.
  function iu(f, w){ var u = url(f); return /^\/\/|^https?:/.test(u) ? u + '&width=' + w : u; }
  function iss(f, ws){ var u = url(f); if(!/^\/\/|^https?:/.test(u)) return '';
    return ws.map(function(w){ return u + '&width=' + w + ' ' + w + 'w'; }).join(','); }
  function imgAttr(f, dflt, ws, sizes){
    var ss = iss(f, ws);
    return 'src="' + iu(f, dflt) + '"' + (ss ? ' srcset="' + ss + '" sizes="' + sizes + '"' : '');
  }
  /* Product-media URLs are printed by Liquid with a &width= already on them,
     so the width is SWAPPED here, not appended: a second &width= would leave
     Shopify's CDN serving the first value while the srcset advertised the
     second, and the browser would pick the wrong candidate on every slide. */
  function mu(u, w){
    return /[?&]width=\d+/.test(u)
      ? u.replace(/([?&])width=\d+/, '$1width=' + w)
      : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  // One call site for both slide kinds: a product-media slide carries .url,
  // a theme-asset slide carries .img and falls through to imgAttr unchanged.
  function slideAttr(s, dflt, ws, sizes){
    if(!s.url) return imgAttr(s.img, dflt, ws, sizes);
    var ss = ws.map(function(w){ return mu(s.url, w) + ' ' + w + 'w'; }).join(',');
    return 'src="' + mu(s.url, dflt) + '" srcset="' + ss + '" sizes="' + sizes + '"';
  }
  /* ---- studio-ground matching ----------------------------------------------
     A packshot sits on a studio ground - pure white, or, once the photographer
     matches the site, some near-miss cream. Either way it rarely equals
     --paper-2 exactly, and those few points of difference read as a panel edge
     drawn around the photo. Rather than asking for a re-export each time, the
     ground is measured and pulled onto --paper-2 in the browser.

     Which photos qualify is MEASURED, never assumed. The image is fetched at
     64px (same origin, so the canvas stays untainted) and its border ring is
     read: a studio ground is bright (mean >= 200 per channel) and flat (sd <=
     12). On this product's ten photos the packshot measures mean 244,237,221
     with sd 3.4,3.4,8.8, while every other slide - infographics with green
     frames, lifestyle shots - lands at sd 41-115. Nothing else is close, so the
     correction can never wander onto a photo that has a real background.

     Then the ground's three correction ratios decide HOW:

     - Ratios nearly equal (the cream case: 1.045 / 1.042 / 1.041, spread
       0.004) means the ground is already the right hue and only a shade dark,
       so a plain brightness() lands it within a point of --paper-2 per channel.
       Nothing is blended, which matters: the bottle's white cap stays white.
     - Ratios far apart (pure white: 1.000 / 0.969 / 0.902) cannot be fixed by
       one scalar, so that ground falls back to multiply onto --paper-2, which
       maps 255,255,255 onto it exactly. This does warm the near-white parts of
       the product, which is the price of a white sweep and the reason a ground
       shot in --paper-2 is the better source. */
  var PAPER = [255, 247, 230];   // --paper-2, the ground the page itself is on
  var GROUND = {};               // url -> brightness factor | 'multiply' | null
  function probeGround(u, cb){
    if(u in GROUND){ cb(GROUND[u]); return; }
    var im = new Image();
    im.onload = function(){
      var w = im.naturalWidth, h = im.naturalHeight, out = null;
      try {
        var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
        var cx = cv.getContext('2d'); cx.drawImage(im, 0, 0);
        var d = cx.getImageData(0, 0, w, h).data;
        var sum = [0,0,0], sq = [0,0,0], n = 0, c, i, x, y;
        var take = function(px, py){
          i = (py * w + px) * 4; n++;
          for(c = 0; c < 3; c++){ sum[c] += d[i+c]; sq[c] += d[i+c] * d[i+c]; }
        };
        for(x = 0; x < w; x++){ take(x, 0); take(x, h - 1); }
        for(y = 0; y < h; y++){ take(0, y); take(w - 1, y); }
        var flat = true, mean = [0,0,0];
        for(c = 0; c < 3; c++){
          mean[c] = sum[c] / n;
          if(mean[c] < 200 || Math.sqrt(Math.max(0, sq[c]/n - mean[c]*mean[c])) > 12) flat = false;
        }
        if(flat){
          var r = [PAPER[0]/mean[0], PAPER[1]/mean[1], PAPER[2]/mean[2]];
          var lo = Math.min(r[0], r[1], r[2]), hi = Math.max(r[0], r[1], r[2]);
          var k = (r[0] + r[1] + r[2]) / 3;
          if(hi - lo <= 0.02){
            // Same hue, slightly off in level: one scalar fixes it, nothing blends.
            // Outside this range the lift would wash the product out, so it is
            // left exactly as shot.
            if(k >= 0.85 && k <= 1.2) out = Math.round(k * 1e4) / 1e4;
          } else if(mean[0] > 246 && mean[1] > 246 && mean[2] > 246){
            out = 'multiply';
          }
        }
      } catch(e){ out = null; }
      GROUND[u] = out; cb(out);
    };
    im.onerror = function(){ GROUND[u] = null; cb(null); };
    im.src = mu(u, 64);
  }
  // Measure every product photo once, then redraw only if something was found:
  // a gallery of infographics never repaints, so there is no flash for nothing.
  function probeMedia(){
    var urls = [];
    ['liquid','powder'].forEach(function(k){
      (DATA[k].media || []).forEach(function(m){ if(urls.indexOf(m.u) < 0) urls.push(m.u); });
    });
    var left = urls.length, hit = false;
    if(!left) return;
    urls.forEach(function(u){
      probeGround(u, function(g){ if(g) hit = true; if(--left === 0 && hit) renderGallery(); });
    });
  }
  // Money formatting mirrors Shopify's own output for the active market/currency:
  // we render 1234.56 through the `money` filter server-side and reverse-engineer
  // prefix/suffix, thousands + decimal separators and fraction digits from it.
  var MFMT = (function(){
    var s = CFG.money || '';
    var o = { pre:'', suf:'', th:',', dec:'.', frac:2 };
    var m = s.match(/[0-9][0-9.,'’    ]*[0-9]/);
    if(!m) return o;
    o.pre = s.slice(0, m.index);
    o.suf = s.slice(m.index + m[0].length);
    var n = m[0], sep = /[^0-9]/;
    if(sep.test(n.charAt(n.length-3))){
      o.dec = n.charAt(n.length-3);
      o.th  = sep.test(n.charAt(n.length-7)) ? n.charAt(n.length-7) : '';
    } else {
      o.frac = 0;
      o.th   = sep.test(n.charAt(n.length-4)) ? n.charAt(n.length-4) : '';
    }
    return o;
  })();
  function money(cents){
    var neg = cents < 0;
    var s = (Math.abs(Math.round(cents))/100).toFixed(MFMT.frac);
    var p = s.split('.');
    var ip = MFMT.th ? p[0].replace(/\B(?=(\d{3})+(?!\d))/g, MFMT.th) : p[0];
    return (neg?'-':'') + MFMT.pre + ip + (p[1] ? MFMT.dec + p[1] : '') + MFMT.suf;
  }
  function esc(s){ return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }

  var L = CFG.liquid || {}, P = CFG.powder || {};
  var DATA = {
    liquid: {
      name:'Liquid Drops', accent:'#ff6b3d', accentHover:'#e85526', accentSoft:'var(--paper-2)',
      variantId: L.variantId,
      amazonUrl: L.amazonUrl,
      price: L.price,
      available: L.available,
      rating: L.rating,
      reviewCount: L.reviewCount,
      img:'product-bottle-drops.png',
      gallery:[
        {label:'Bottle', img:'liq-hero.jpg', white:true},
        {label:'6 drops', img:'liq-drops.jpg'},
        {label:'Facts', img:'liq-facts.jpg'},
        {label:'Health', img:'liq-health.jpg'}
      ],
      desc:'Pure monk fruit. One ingredient, zero glycemic impact.',
      size:'75 ml · 250 servings',
      howto:'Add 3–5 drops to coffee, tea, yoghurt or batter and stir. A little goes a long way, so start low and adjust to taste.',
      ingredients:'100% monk fruit decoction (Siraitia grosvenorii) — and nothing else.',
      storage:'Store in a cool, dry place away from direct sunlight. Reseal the cap after each use; no refrigeration needed.',
      badgePfx:'dg',
      nutriCols:['Per 100 g','Per 6 drops'],
      nutri:[
        {l:'Energy', strong:true, a:'277 kcal', aKj:'1,160 kJ', b:'1 kcal', bKj:'4.7 kJ'},
        {l:'Fat', strong:true, a:'0 g', b:'0 g'},
        {l:'of which saturates', indent:true, a:'0 g', b:'0 g'},
        {l:'Carbohydrate', strong:true, a:'69 g', b:'0.3 g'},
        {l:'of which sugars', indent:true, a:'55 g', b:'0.2 g'},
        {l:'Protein', strong:true, a:'0 g', b:'0 g'},
        {l:'Salt', strong:true, a:'0.016 g', b:'0 g'}
      ],
      nutriFoot:'*Mogrosides are included in total carbohydrate. Approved for use as food in the EU & UK.'
    },
    powder: {
      name:'Monkfruit Powder', accent:'#4ea48a', accentHover:'#3e8b73', accentSoft:'#e7f1ec',
      variantId: P.variantId,
      amazonUrl: P.amazonUrl,
      price: P.price,
      available: P.available,
      rating: P.rating,
      reviewCount: P.reviewCount,
      img:'powder-hero-p2.jpg',
      gallery:[
        {label:'New size', img:'pwd-newsize-p2.jpg'},
        {label:'90% less', img:'pwd-calories.png'},
        {label:'1.5 kcal', img:'pwd-facts.png'},
        {label:'Clean choice', img:'pwd-clean.png'}
      ],
      desc:'Spoonable monk fruit with prebiotic tapioca fibre — 3–5× sweeter than sugar, about 1.5 kcal a serving. Measures easily for baking and drinks.',
      size:'200 g · 150 servings',
      howto:'Spoon into coffee, tea and yoghurt, or swap it into recipes. It is sweeter than sugar, so begin with less and taste as you go.',
      ingredients:'Monk fruit decoction with prebiotic tapioca (cassava) fibre. No erythritol, maltodextrin or fillers.',
      storage:'Store in a cool, dry place away from direct sunlight. Reseal the pouch after each use; no refrigeration needed.',
      badgePfx:'cr',
      nutriCols:['Per 100 g','Per 1.5 g'],
      nutri:[
        {l:'Energy', strong:true, a:'250 kcal', aKj:'1,046 kJ', b:'4 kcal', bKj:'17 kJ'},
        {l:'Fat', strong:true, a:'0 g', b:'0 g'},
        {l:'Carbohydrate', strong:true, a:'97 g', b:'1.5 g'},
        {l:'of which sugars', indent:true, a:'25 g', b:'0.4 g'},
        {l:'of which fibre', indent:true, a:'66 g', b:'1.0 g'},
        {l:'Protein', strong:true, a:'0 g', b:'0 g'},
        {l:'Salt', strong:true, a:'0.03 g', b:'0 g'}
      ],
      nutriFoot:'Per serving of 1.5 g. Includes prebiotic tapioca fibre. Approved for use as food in the EU & UK.'
    }
  };
  /* ---- translatable copy ---------------------------------------------------
     The English strings above stay exactly where they were and remain the
     fallback. Whenever the section supplies a value through CFG.products /
     CFG.ui — printed by snippets/hmf-product-js.liquid from settings that live
     in the template, and are therefore reachable by Shopify's translation API —
     that value replaces the literal. Same blocks-then-fallback shape the FAQ
     below already uses, so the emitted markup is identical either way.

     Only wording is ever taken from CFG. The figures, units, kJ values, the
     strong/indent flags and the row order stay in DATA above, untouched: the
     nutrition table is overlaid label-by-label, never rebuilt. An empty or
     missing value counts as "not configured" and leaves the literal in place,
     so a template that was never filled in renders what it always rendered.

     CFG.products is keyed by product ('powder' / 'liquid'). A product template
     carries the copy for its own product only; the other tab keeps the
     literals here. */
  var UI = CFG.ui || {};
  var UIB = UI.badges || {};
  function cfgStr(v){ return (typeof v === 'string' && v !== '') ? v : null; }
  // Plain text, for the call sites that already run their value through esc().
  function uiText(k, dflt){ var v = cfgStr(UI[k]); return v === null ? dflt : v; }
  // HTML-ready, for the call sites that concatenate a literal straight into
  // markup: a CFG value is escaped here, the literal fallback already is.
  function uiHtml(k, dflt){ var v = cfgStr(UI[k]); return v === null ? dflt : esc(v); }
  (function applyProductCopy(){
    var src = CFG.products || {};
    Object.keys(DATA).forEach(function(key){
      var c = src[key], d = DATA[key];
      if(!c) return;
      ['name','desc','size','howto','ingredients','storage','nutriFoot'].forEach(function(f){
        var v = cfgStr(c[f]); if(v !== null) d[f] = v;
      });
      if(c.galleryLabels) c.galleryLabels.forEach(function(s,i){
        var v = cfgStr(s); if(v !== null && d.gallery[i]) d.gallery[i].label = v;
      });
      if(c.nutriCols) c.nutriCols.forEach(function(s,i){
        var v = cfgStr(s); if(v !== null && i < d.nutriCols.length) d.nutriCols[i] = v;
      });
      if(c.nutriLabels) c.nutriLabels.forEach(function(s,i){
        var v = cfgStr(s); if(v !== null && d.nutri[i]) d.nutri[i].l = v;
      });
    });
  })();
  /* ---- real product photos ------------------------------------------------
     When a product has a proper gallery in Shopify (more than one image), that
     gallery wins over the theme-asset slides hard-coded in DATA above, so
     swapping listing photos is done in Products -> Media and never needs a
     theme edit. One photo or none leaves DATA alone - which is what the Powder
     still runs on until its own media is uploaded. */
  (function applyProductMedia(){
    ['liquid','powder'].forEach(function(k){
      var m = CFG[k] && CFG[k].media;
      if(m && m.length > 1) DATA[k].media = m;
    });
  })();
  var BADGES = [['natural','100% Natural',88],['gmo','GMO Free',88],['keto','Keto Friendly',72],['one','One Ingredient',88],['vegan','Vegan',88],['zero','Zero Glycemic Index',72]];
  var FAQ_BODIES = [
    ["We ship orders the same day, and they typically arrive within 3 days anywhere in Europe. While we always choose the best carriers, sometimes there can be delays beyond our control. If you have any issues or want an update on your order, just email us at support@happymonkfruit.com and we’ll help you out!"],
    ["Monkfruit is similar to Stevia, but while Stevia comes from barely edible leaves, Monkfruit is extracted from the fruit called Luo Han Guo.","Both Monkfruit and Stevia are about 15 times sweeter than sugar, but Monkfruit has a smoother, milder taste without the harsh aftertaste Stevia often has.","Erythritol, on the other hand, is a sugar alcohol that’s actually less sweet than sugar, meaning you need to use quite a lot of it.","We created our Monkfruit sweetener because Stevia and Erythritol have been associated with some potential health concerns, like gut issues, heart problems, and hormone disruption, and we simply don’t want that for our families.","Monkfruit has been used safely for over 800 years without known side effects. It’s even associated with anti-inflammatory and gut-friendly benefits, although we don’t make any health claims about it.","Monkfruit has a pleasantly sweet taste and syrup-like texture that’s ideal for yogurt, coffee, tea, desserts, or beverages."],
    ["We understand everyone’s taste is different, and Monkfruit can have a strong sweetness for some people. No worries! Just drop us an email at support@happymonkfruit.com, let us know what’s up, and we’ll gladly give you your money back."],
    ["You can definitely bake with Monkfruit Sweetener, though it doesn’t caramelize or add the crunchy texture regular sugar does. It works best in creamy desserts, cake fillings, or recipes combined with other sweet ingredients like fruits, honey, maple syrup, or inulin to boost flavor.","You might need to experiment a bit to find your favorite method — check out some of our recipes for inspiration!"],
    ["Yes, monk fruit sweetener does have a bit of an aftertaste, but it’s not bitter like stevia or some artificial sweeteners. It’s more of a lingering sweetness that hangs around in your mouth longer than regular sugar would, since it’s more concentrated.","Reactions vary. Some enjoy the extended sweetness, others find it off-putting. If you dislike the lingering effect, try using less or mixing it with other sweeteners for balance."],
    ["There are a few reasons for that. Monkfruit is actually pretty challenging to grow — it’s labor-intensive and only grows in mountainous regions, which makes harvesting much harder.","It also doesn’t stay fresh for very long, so we have to process it right away after harvesting. It’s more expensive to produce than something like stevia because we’re using the actual fruit rather than leaves, which are more abundant and easier to harvest.","You might see some cheaper American brands of monkfruit out there, but those are processed differently and actually most of the time aren’t legally approved for sale in the EU.","We follow all EU regulations, which impacts our pricing but ensures you’re getting a properly vetted product.","Also, we sell pure monkfruit and don’t add erythritol and other additives and hide them in small letters on the back of the package :)"],
    ["Yes, we’re an EU brand! All our products are bottled and labeled in Slovakia, and our bottles, labels, and all packaging are made in the EU.","The monk fruit itself comes from southern China since that’s the only place where it naturally grows. Our team is a mix of Slovak, French, Italian and Irish folks."]
  ];

  // ---- state ----
  var S = { active: ROOT.dataset.active === 'liquid' ? 'liquid' : 'powder', slide:0, plan:'onetime', qty:1, moreOpen:false };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io, ioLate; // scroll-reveal observers (early / late), assigned during init below

  function slidesFor(p){
    // Product media: already in the merchant's chosen order, first one first.
    // They are square and the stage is 1:1, so `cover` fills it without cropping.
    if(p.media && p.media.length){
      return p.media.map(function(m, i){
        return { url:m.u, fit:'cover', bg:'var(--paper-2)', ground: GROUND[m.u] || 0,
                 label: m.a || (uiText('slideProductLabel','Product') + ' ' + (i+1)) };
      });
    }
    var arr=[{img:p.img, fit:'contain', bg:'var(--paper-2)', label:uiText('slideProductLabel','Product')}];
    /* `white:true` marks a photo shot on a pure white sweep. Instead of
       re-editing the bitmap we paint the stage with --paper-2 and let the image
       multiply onto it: every 255,255,255 pixel resolves to exactly --paper-2,
       so the shot melts into the page background, while the product itself only
       picks up a ~3% warm shift that is invisible against this palette. Doing
       it in CSS also keeps the source asset untouched and reversible. */
    p.gallery.forEach(function(g){
      arr.push({img:g.img, fit:'cover', label:g.label, blend:!!g.white,
                bg: g.white ? 'var(--paper-2)' : 'transparent'});
    });
    return arr;
  }
  // Shopify's automatic discounts allocate the percentage per unit and drop the
  // leftover cent fraction, so 21,90 EUR at -5% is 21,90 - 1,09 = 20,81 a unit
  // (not 20,805). Integer math here keeps the button identical to the cart.
  function tierPct(units){ return units>=3 ? 10 : (units===2 ? 5 : 0); }
  function tierTotal(unit, units){ return (unit - Math.floor(unit * tierPct(units) / 100)) * units; }

  function applyAccent(p){
    ROOT.style.setProperty('--accent', p.accent);
    ROOT.style.setProperty('--accent-hover', p.accentHover);
    ROOT.style.setProperty('--accent-soft', p.accentSoft);
  }

  /* Dragging or double-clicking a photo selected it, and a selected image is
     painted over with the browser's blue highlight, which read as the gallery
     having gone wrong. Images are not text; nothing is lost by opting out. */
  var NOSEL = ';user-select:none;-webkit-user-select:none;-webkit-user-drag:none';
  function slideStyle(s){
    var st = s.fit==='cover' ? 'width:100%;height:100%;object-fit:cover' : 'max-width:96%;max-height:96%;object-fit:contain';
    if(s.ground === 'multiply' || s.blend) st += ';mix-blend-mode:multiply';
    else if(s.ground) st += ';filter:brightness(' + s.ground + ')';
    return st + NOSEL;
  }

  function renderGallery(){
    var p=DATA[S.active], slides=slidesFor(p), cur=slides[S.slide]||slides[0];
    var stage=ROOT.querySelector('[data-gallery-stage]');
    var st = slideStyle(cur);
    stage.style.background = cur.bg;
    // A media slide's label IS its alt text from Shopify, so it stands alone;
    // a theme-asset slide only has a short label and gets the product name too.
    var calt = cur.url ? cur.label : (p.name+' — '+cur.label);
    stage.innerHTML = '<img '+slideAttr(cur, 1000, [500,700,900,1200], '(max-width:920px) 92vw, 670px')+' alt="'+esc(calt)+'" decoding="async" fetchpriority="high" style="'+st+'">';
    var tr=ROOT.querySelector('[data-thumbrow]');
    tr.innerHTML = slides.map(function(s,i){
      // A corrected slide has to sit on --paper-2 for the maths to land on
      // --paper-2, so that wins over the first thumb's usual accent tint.
      var tb = (s.blend || s.ground) ? 'var(--paper-2)' : (i===0 ? 'var(--accent-soft)' : 'transparent');
      var ist = slideStyle(s);
      return '<button type="button" class="thumb" data-thumb="'+i+'" data-on="'+(i===S.slide?'true':'false')+'" style="aspect-ratio:1/1" aria-label="'+esc(s.label)+'">'+
        '<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;background:'+tb+'"><img '+slideAttr(s, 260, [130,260], '130px')+' alt="'+esc(s.label)+'" loading="lazy" decoding="async" style="'+ist+'"></div></button>';
    }).join('');
  }

  function syncExpress(){
    var units = (S.plan==='pack2'?2:S.plan==='pack3'?3:1) * S.qty;
    ROOT.querySelectorAll('[data-express]').forEach(function(w){
      var on = w.getAttribute('data-express')===S.active;
      w.setAttribute('data-off', on ? '0' : '1');
      if(on){ var q=w.querySelector('[data-express-qty]'); if(q){ q.value = units; } }
    });
  }
  /* ---- rating badge -------------------------------------------------------
     A star row under the H1, straight from Judge.me's aggregate. It reuses the
     .hmfjm-stars markup that snippets/hmf-reviews.liquid styles, so the two
     places on the page that draw stars can never drift apart, and it renders
     nothing at all when a product has no reviews yet — the Powder today. */
  var JM_STAR = 'M12 .587l3.668 7.431 8.2 1.192-5.934 5.784 1.401 8.168L12 18.896l-7.335 3.866 1.401-8.168L.132 9.21l8.2-1.192z';
  function ratingBadge(p){
    var n = parseInt(p.reviewCount, 10) || 0;
    if (!n) return '';
    var v = parseFloat(p.rating) || 0;
    if (!v) return '';
    var pct = Math.max(0, Math.min(5, v)) * 20;
    var row = '';
    for (var i = 0; i < 5; i++) row += '<i><svg viewBox="0 0 24 24"><path d="' + JM_STAR + '"></path></svg></i>';
    return '<a href="#hmf-reviews" data-rate-badge aria-label="' + v + ' out of 5 stars, ' + n + ' reviews"' +
      ' style="display:flex;align-items:center;justify-content:center;gap:9px;margin:13px auto 0;text-decoration:none">' +
      '<span class="hmfjm-stars" style="--jm-pct:' + pct + '%;font-size:17px" aria-hidden="true">' +
        '<span class="hmfjm-stars-bg">' + row + '</span>' +
        '<span class="hmfjm-stars-fg"><span class="hmfjm-srow">' + row + '</span></span>' +
      '</span>' +
      '<span style="font-family:var(--font-display);font-weight:700;font-size:15px;color:var(--green)">' + esc(p.rating) + '</span>' +
      '<span style="font-size:13.5px;color:var(--ink-soft);border-bottom:1px solid rgba(17,94,70,.28)">' +
        n + ' ' + (n === 1 ? uiHtml('reviewsOne','review') : uiHtml('reviewsMany','reviews')) + '</span>' +
    '</a>';
  }
  function renderBuybox(){
    var p=DATA[S.active];
    var _az=ROOT.querySelector('[data-amazon-btn]'); if(_az && p.amazonUrl){ _az.href=p.amazonUrl; }
    var base=p.price;
    var mult = S.plan==='pack2'?2 : S.plan==='pack3'?3 : 1;
    var units = mult * S.qty;
    var atcCents = tierTotal(base, units);
    var t2 = money(tierTotal(base, 2));
    var t3 = money(tierTotal(base, 3));
    var planLabel = {onetime:uiHtml('planOnetime','One-time'),pack2:uiHtml('planPack2','2-pack'),pack3:uiHtml('planPack3','3-pack')}[S.plan]||uiHtml('planOnetime','One-time');
    var soldOut = !p.available;

    /* The heading is rendered by Liquid and lives outside [data-buybox], whose
       innerHTML is replaced wholesale below. Update its text rather than
       building a second one: the page then has exactly one H1, present in the
       server HTML, and switching tabs still renames it. */
    var h1 = ROOT.querySelector('[data-pdp-h1]');
    if (h1) h1.textContent = p.name;

    var bb=ROOT.querySelector('[data-buybox]');
    bb.innerHTML =
      ratingBadge(p)+
      '<p style="font-size:17.5px;line-height:1.6;color:var(--ink-soft);margin:14px auto 0;max-width:46ch;text-align:center">'+esc(p.desc)+'</p>'+
      '<div class="price-blk" style="display:flex;flex-direction:column;align-items:center;gap:4px;margin-top:26px">'+
        '<span style="font-family:var(--font-display);font-weight:700;font-size:40px;color:var(--green)">'+money(base)+'</span>'+
        '<span style="font-size:14px;color:var(--ink-soft)">'+esc(p.size)+'</span>'+
      '</div>'+
      '<div class="plan-blk" style="margin-top:24px">'+
        '<div style="font-family:var(--font-body);font-size:14px;color:var(--ink-soft);margin-bottom:10px"><strong style="font-family:var(--font-display);color:var(--green);font-weight:700">'+uiHtml('planLabel','Plan:')+'</strong> '+planLabel+'</div>'+
        '<div style="display:flex;flex-direction:column;gap:10px">'+
          '<button type="button" class="planopt" data-plan="onetime" data-on="'+(S.plan==='onetime'?'true':'false')+'">'+
            '<span class="pradio"><span class="pdot"></span></span>'+
            '<span style="flex:1;font-family:var(--font-display);font-weight:600;font-size:16px;color:var(--green)">'+uiHtml('planOnetime','One-time')+'</span>'+
            '<span style="font-family:var(--font-display);font-weight:700;font-size:16px;color:var(--green)">'+money(base)+'</span>'+
          '</button>'+
          '<div class="more-acc" data-open="'+(S.moreOpen?'true':'false')+'" data-sel="'+((S.plan==='pack2'||S.plan==='pack3')?'true':'false')+'" style="background:var(--white);border:1.5px solid var(--line);border-radius:16px;overflow:hidden">'+
            '<button type="button" data-more-toggle aria-expanded="'+(S.moreOpen?'true':'false')+'" style="display:flex;align-items:center;gap:12px;width:100%;background:transparent;border:0;cursor:pointer;padding:16px 18px;font-family:var(--font-body)">'+
              '<span style="flex:1;text-align:left;font-family:var(--font-display);font-weight:600;font-size:16px;color:var(--green)">'+uiHtml('buyMore','Buy more &amp; save')+'</span>'+
              '<span style="font-family:var(--font-body);font-size:12.5px;font-weight:700;color:var(--coral)">'+uiHtml('buyMoreNote','Up to 10% off')+'</span>'+
              '<svg class="more-chev" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--green)" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" style="flex:none"><polyline points="6 9 12 15 18 9"></polyline></svg>'+
            '</button>'+
            '<div class="more-body"><div style="padding:0 14px 14px;display:flex;flex-direction:column;gap:10px">'+
              '<button type="button" class="planopt" data-plan="pack2" data-on="'+(S.plan==='pack2'?'true':'false')+'" style="padding:14px 16px">'+
                '<span class="pradio"><span class="pdot"></span></span>'+
                '<span style="flex:1;display:flex;align-items:center;gap:9px;font-family:var(--font-display);font-weight:600;font-size:16px;color:var(--green)">'+uiHtml('planPack2','2-pack')+' <span style="font-family:var(--font-body);font-size:12px;font-weight:700;color:var(--coral);background:var(--paper-2);border-radius:999px;padding:3px 9px">'+uiHtml('savePack2','Save 5%')+'</span></span>'+
                '<span style="font-family:var(--font-display);font-weight:700;font-size:16px;color:var(--green)">'+t2+'</span>'+
              '</button>'+
              '<button type="button" class="planopt" data-plan="pack3" data-on="'+(S.plan==='pack3'?'true':'false')+'" style="padding:14px 16px">'+
                '<span class="pradio"><span class="pdot"></span></span>'+
                '<span style="flex:1;display:flex;align-items:center;gap:9px;font-family:var(--font-display);font-weight:600;font-size:16px;color:var(--green)">'+uiHtml('planPack3','3-pack')+' <span style="font-family:var(--font-body);font-size:12px;font-weight:700;color:var(--coral);background:var(--paper-2);border-radius:999px;padding:3px 9px">'+uiHtml('savePack3','Save 10%')+'</span></span>'+
                '<span style="font-family:var(--font-display);font-weight:700;font-size:16px;color:var(--green)">'+t3+'</span>'+
              '</button>'+
            '</div></div>'+
          '</div>'+
        '</div>'+
      '</div>'+
      '<div class="atc-row" style="display:flex;gap:12px;margin-top:24px;align-items:stretch">'+
        '<div style="display:flex;align-items:center;border:1.5px solid var(--line);border-radius:999px;background:var(--white);padding:2px">'+
          '<button type="button" class="qbtn" data-qty-dec aria-label="Decrease">−</button>'+
          '<span style="min-width:34px;text-align:center;font-family:var(--font-display);font-weight:700;font-size:17px;color:var(--green)">'+S.qty+'</span>'+
          '<button type="button" class="qbtn" data-qty-inc aria-label="Increase">+</button>'+
        '</div>'+
        '<button type="button" class="cta cta-accent" data-atc '+(soldOut?'disabled':'')+' style="flex:1;font-size:15px;padding:0 26px">'+
          (soldOut ? uiHtml('soldOut','Sold out') : (uiHtml('addToCart','Add to cart')+' · '+money(atcCents)))+
        '</button>'+
      '</div>';
    syncExpress();
  }

  function renderDetails(){
    var p=DATA[S.active], pw = S.active==='powder';
    var band=ROOT.querySelector('[data-details-band]'), grid=ROOT.querySelector('[data-details]');
    band.style.background = pw ? '#115E46' : 'var(--cream)';
    var head = pw ? 'var(--cream)' : 'var(--green)';
    var ink = pw ? 'rgba(255,243,197,.92)' : 'var(--ink-soft)';
    var bar = pw ? 'var(--cream)' : 'var(--green)';
    var lineStrong = pw ? 'rgba(255,243,197,.42)' : 'rgba(17,94,70,.25)';
    var lineSoft = pw ? 'rgba(255,243,197,.24)' : 'rgba(17,94,70,.16)';
    var foot = pw ? 'rgba(255,243,197,.72)' : 'var(--ink-soft)';
    grid.style.background = pw ? '#115E46' : 'var(--cream)';

    var nutriRows = p.nutri.map(function(r,i){
      if(i===0){
        return '<div style="display:grid;grid-template-columns:1.6fr .8fr .8fr;align-items:baseline;padding:9px 0">'+
          '<span style="font-family:var(--font-display);font-weight:700;font-size:23px;color:'+head+'">'+esc(r.l)+'</span>'+
          '<span style="text-align:right"><span style="font-family:var(--font-display);font-weight:700;font-size:20px;color:'+head+'">'+esc(r.a)+'</span>'+(r.aKj?'<span style="display:block;font-size:11px;color:'+ink+';margin-top:1px">'+esc(r.aKj)+'</span>':'')+'</span>'+
          '<span style="text-align:right"><span style="font-family:var(--font-display);font-weight:700;font-size:20px;color:'+head+'">'+esc(r.b)+'</span>'+(r.bKj?'<span style="display:block;font-size:11px;color:'+ink+';margin-top:1px">'+esc(r.bKj)+'</span>':'')+'</span>'+
        '</div><div style="height:6px;background:'+bar+'"></div>';
      }
      var labelStyle = r.strong ? 'font-family:var(--font-display);font-weight:700;font-size:15px;color:'+head : ('font-size:14.5px;color:'+ink+';padding-left:'+(r.indent?'18px':'0'));
      var valStyle = 'font-family:var(--font-display);font-weight:'+(r.strong?700:600)+';font-size:14.5px;color:'+(r.strong?head:ink);
      return '<div style="display:grid;grid-template-columns:1.6fr .8fr .8fr;align-items:baseline;padding:8px 0;border-bottom:1px solid '+lineSoft+'">'+
        '<span style="'+labelStyle+'">'+esc(r.l)+'</span>'+
        '<span style="text-align:right"><span style="'+valStyle+'">'+esc(r.a)+'</span></span>'+
        '<span style="text-align:right"><span style="'+valStyle+'">'+esc(r.b)+'</span></span>'+
      '</div>';
    }).join('');

    var badgesHtml = BADGES.map(function(b){
      return '<img '+imgAttr(p.badgePfx+'-badge-'+b[0]+'.png', 240, [120,240], (b[2]*1.3|0)+'px')+' alt="'+esc(cfgStr(UIB[b[0]]) || b[1])+'" style="height:'+b[2]+'px;width:auto;flex:0 0 auto" loading="lazy" decoding="async">';
    }).join('');

    grid.innerHTML =
      '<div class="hmf-rv">'+
        '<div style="font-family:var(--font-display);font-weight:600;text-transform:uppercase;letter-spacing:.18em;font-size:13px;color:var(--coral);margin-bottom:14px">'+uiHtml('detailsEyebrow','Product details')+'</div>'+
        // The product name (p.name) and its one-line tagline (p.desc) were rendered
        // here as an <h2> + <p>. Removed as a duplicate: both already appear at the
        // top of the page in the buy box beside the product images (renderBuybox).
        // The powder_name / liquid_name / powder_desc / liquid_desc section settings
        // are intentionally KEPT - the buy box still renders them and they carry the
        // translations for all 8 locales.
        '<p style="font-size:15.5px;line-height:1.72;color:'+ink+';margin-top:22px;max-width:56ch"><strong style="color:'+head+';font-family:var(--font-display);font-weight:700">'+uiHtml('howtoLabel','How to use:')+'</strong> '+esc(p.howto)+'</p>'+
        '<p style="font-size:15.5px;line-height:1.72;color:'+ink+';margin-top:16px;max-width:56ch"><strong style="color:'+head+';font-family:var(--font-display);font-weight:700">'+uiHtml('ingredientsLabel','Ingredients:')+'</strong> '+esc(p.ingredients)+'</p>'+
        '<p style="font-size:15.5px;line-height:1.72;color:'+ink+';margin-top:16px;max-width:56ch"><strong style="color:'+head+';font-family:var(--font-display);font-weight:700">'+uiHtml('storageLabel','Storage:')+'</strong> '+esc(p.storage)+'</p>'+
      '</div>'+
      '<div class="nutri-col hmf-rv hmf-rv-late" style="font-family:var(--font-body);max-width:400px;justify-self:end;width:100%">'+
        '<div style="border:1.5px solid '+lineStrong+';border-radius:18px;padding:24px 26px 22px">'+
          '<div style="font-family:var(--font-display);font-weight:700;font-size:36px;color:'+head+';line-height:1;letter-spacing:-.01em">'+uiHtml('nutritionHeading','Nutrition Facts')+'</div>'+
          '<div style="font-size:13.5px;color:'+ink+';margin-top:7px">'+esc(p.size)+'</div>'+
          '<div style="height:9px;background:'+bar+';margin-top:9px"></div>'+
          '<div style="display:grid;grid-template-columns:1.6fr .8fr .8fr;padding:7px 0 6px;font-family:var(--font-display);font-weight:700;font-size:11.5px;color:'+head+';text-transform:uppercase;letter-spacing:.03em;border-bottom:1px solid '+lineStrong+'">'+
            '<span></span><span style="text-align:right">'+esc(p.nutriCols[0])+'</span><span style="text-align:right">'+esc(p.nutriCols[1])+'</span>'+
          '</div>'+
          nutriRows+
          '<div style="height:6px;background:'+bar+';margin-top:1px"></div>'+
          '<div style="font-size:11.5px;color:'+foot+';line-height:1.55;margin-top:11px">'+esc(p.nutriFoot)+'</div>'+
        '</div>'+
      '</div>'+
      '<div class="badge-row hmf-rv" style="grid-column:1 / -1;margin-top:40px;display:flex;align-items:center;justify-content:space-between;gap:26px;flex-wrap:wrap">'+badgesHtml+'</div>';
    wireDetailsReveal();
  }

  // Each details child reveals on its own scroll position: text/badges early, the nutrition table later
  // (once the reader has scrolled through the text). If the section is already on screen (e.g. tab switch),
  // everything just shows immediately instead of re-hiding.
  function wireDetailsReveal(){
    var kids = ROOT.querySelectorAll('[data-details] > *');
    if(!io){ kids.forEach(function(k){ k.classList.add('in'); }); return; }
    var sect = ROOT.querySelector('#hmf-details');
    var sr = sect.getBoundingClientRect();
    var alreadyOnScreen = sr.top < window.innerHeight*0.85 && sr.bottom > window.innerHeight*0.15;
    kids.forEach(function(k){
      if(alreadyOnScreen){ k.classList.add('in'); return; }
      (k.classList.contains('hmf-rv-late') ? ioLate : io).observe(k);
    });
  }

  function renderWaves(){
    var c = S.active==='powder' ? '#115E46' : 'var(--cream)';
    ROOT.querySelectorAll('[data-wave]').forEach(function(w){ w.setAttribute('fill', c); });
  }
  function renderTabs(){
    ROOT.querySelectorAll('[data-tab]').forEach(function(b){
      var on = b.getAttribute('data-tab')===S.active;
      b.setAttribute('data-on', on?'true':'false');
      if(b.getAttribute('data-tab')==='powder'){
        b.style.cssText = on ? 'flex:1;background:#4ea48a;color:#fff;box-shadow:0 6px 16px -8px rgba(17,94,70,.35)' : 'flex:1';
      } else {
        b.style.cssText = on ? 'flex:1;background:var(--rest-cream);color:var(--green);box-shadow:0 6px 16px -8px rgba(17,94,70,.35)' : 'flex:1';
      }
    });
  }
  function renderAll(){ applyAccent(DATA[S.active]); renderTabs(); renderGallery(); renderBuybox(); renderDetails(); renderWaves(); }

  function switchTab(key){
    if(key===S.active) return;
    S.active=key; S.slide=0; S.plan='onetime'; S.moreOpen=false; S.qty=1;
    renderAll();
  }

  // ---- delegated events ----
  ROOT.addEventListener('click', function(e){
    var t;
    if(t=e.target.closest('[data-tab]')){ switchTab(t.getAttribute('data-tab')); return; }
    if(t=e.target.closest('[data-thumb]')){ S.slide=parseInt(t.getAttribute('data-thumb'),10)||0; renderGallery(); return; }
    if(e.target.closest('[data-slide-prev]')){ var n=slidesFor(DATA[S.active]).length; S.slide=(S.slide-1+n)%n; renderGallery(); return; }
    if(e.target.closest('[data-slide-next]')){ var n2=slidesFor(DATA[S.active]).length; S.slide=(S.slide+1)%n2; renderGallery(); return; }
    if(t=e.target.closest('[data-plan]')){ S.plan=t.getAttribute('data-plan'); if(S.plan!=='onetime') S.moreOpen=true; renderBuybox(); return; }
    if(e.target.closest('[data-more-toggle]')){ S.moreOpen=!S.moreOpen; renderBuybox(); return; }
    if(e.target.closest('[data-qty-dec]')){ S.qty=Math.max(1,S.qty-1); renderBuybox(); return; }
    if(e.target.closest('[data-qty-inc]')){ S.qty=Math.min(99,S.qty+1); renderBuybox(); return; }
    if(t=e.target.closest('[data-atc]')){ addToCart(t); return; }
    if(e.target.closest('[data-menu-toggle]')){ toggleMenu(); return; }
    if(e.target.closest('[data-menu-close]')){ setMenu(false); return; }
    if(t=e.target.closest('[data-acc-toggle]')){ var acc=t.closest('[data-acc]'); acc.setAttribute('data-open', acc.getAttribute('data-open')==='true'?'false':'true'); return; }
  });

  // ---- add to cart ----
  function addToCart(btn){
    var p=DATA[S.active];
    if(!p.available || !p.variantId){ return; }
    var mult = S.plan==='pack2'?2 : S.plan==='pack3'?3 : 1;
    var units = mult * S.qty;
    var orig = btn.innerHTML;
    btn.disabled = true;
    fetch(CFG.cartAdd + '.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id: p.variantId, quantity: units })
    }).then(function(r){ return r.json().then(function(j){ return {ok:r.ok, j:j}; }); })
      .then(function(res){
        if(!res.ok){ throw new Error((res.j && res.j.description) || 'add failed'); }
        btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="4 12 10 18 20 6"></polyline></svg> ' + uiHtml('added','Added');
        refreshCart(true);
        // If the theme exposes a cart drawer, let it know; otherwise stay on page.
        document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true}));
        setTimeout(function(){ btn.disabled=false; renderBuybox(); }, 1600);
      })
      .catch(function(){
        // Fallback: hard POST via a real form so the user still reaches the cart.
        var f=document.createElement('form'); f.method='post'; f.action=CFG.cartAdd;
        f.innerHTML='<input type="hidden" name="id" value="'+p.variantId+'"><input type="hidden" name="quantity" value="'+units+'">';
        document.body.appendChild(f); f.submit();
      });
  }
  /* Shared cart state. Every block on this page used to fetch /cart.js for
     itself (sticky bar, drawer, header badge, this script) — five round trips
     for one answer. window.HMF.cart() hands out a single in-flight promise and
     caches the result until something actually changes the cart. */
  function cartRead(force){
    if(window.HMF && window.HMF.cart) return window.HMF.cart(force);
    // Helper missing (asset failed to load) — fall back to a direct read so the
    // badge still works rather than throwing and killing the rest of the page.
    return fetch(CFG.cartUrl + '.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; });
  }
  function refreshCart(force){
    return cartRead(force).then(function(c){
      if(!c) return c;
      // The header now lives in its own global section, outside this PDP root,
      // so the badge has to be looked up on the whole document.
      var b=document.querySelector('[data-cart-bubble]');
      if(b){ b.textContent=c.item_count; b.style.display = c.item_count>0 ? 'flex' : 'none'; }
      document.dispatchEvent(new CustomEvent('hmf:cart-updated', { detail: { count: c.item_count } }));
      return c;
    });
  }

  // ---- mobile menu ----
  function setMenu(open){
    var m=ROOT.querySelector('[data-mobile-menu]'), btn=ROOT.querySelector('[data-menu-toggle]');
    if(!m) return;
    m.style.display = open ? 'flex' : 'none';
    if(btn) btn.setAttribute('aria-expanded', open?'true':'false');
  }
  function toggleMenu(){ var m=ROOT.querySelector('[data-mobile-menu]'); if(!m) return; setMenu(m.style.display!=='flex'); }

  // ---- FAQ bodies + nav shadow + reveal ----
  /* Answers come from CFG.faq — the section's `faq` blocks, which are
     translatable — whenever the template supplies them. FAQ_BODIES above stays
     as the fallback for a template with no faq blocks, so the FAQ can never
     render empty and the whole change stays revertible by editing one template.

     Both paths converge on the same renderer below, so the emitted markup is
     identical either way. CFG answers are richtext (`<p>…</p>`), so they are
     reduced to the same array-of-plain-paragraphs shape FAQ_BODIES already
     uses; the paragraphs are then escaped and wrapped in the same styled <p>
     as before. innerHTML on a detached div does not run scripts, and only
     textContent is read back out. */
  var CFG_FAQ = (CFG.faq && CFG.faq.length) ? CFG.faq : null;
  function faqParas(idx){
    if(!CFG_FAQ) return FAQ_BODIES[idx]||[];
    var entry=CFG_FAQ[idx];
    if(!entry || !entry.a) return [];
    var d=document.createElement('div'); d.innerHTML=entry.a;
    var out=[];
    d.querySelectorAll('p').forEach(function(p){ var t=(p.textContent||'').trim(); if(t) out.push(t); });
    // richtext should always be wrapped in <p>, but tolerate a bare string.
    if(!out.length){ var bare=(d.textContent||'').trim(); if(bare) out.push(bare); }
    return out;
  }
  ROOT.querySelectorAll('[data-faq-body]').forEach(function(el){
    var idx=parseInt(el.getAttribute('data-faq-body'),10);
    var paras=faqParas(idx);
    el.innerHTML = paras.map(function(x){ return '<p style="font-size:15.5px;line-height:1.72;color:var(--ink-soft);margin-bottom:12px">'+esc(x)+'</p>'; }).join('');
  });

  var nav=ROOT.querySelector('[data-nav]');
  /* Guarded: the old handler wrote nav.style.boxShadow on EVERY scroll event,
     forcing a style recalculation and a repaint on every frame of every scroll.
     Now the style is only touched when the state flips, inside a rAF. */
  var hmfShadowOn = null;
  window.addEventListener('scroll', function(){
    if(!nav) return;
    var on = (window.scrollY||document.documentElement.scrollTop) > 10;
    if(on === hmfShadowOn) return;
    hmfShadowOn = on;
    requestAnimationFrame(function(){
      nav.style.boxShadow = on ? '0 8px 24px rgba(19,53,42,.10)' : '0 1px 0 rgba(19,53,42,.04)';
    });
  }, {passive:true});

  // Shared reveal callback (observer arrives as 2nd arg, so one fn serves both triggers).
  function hmfRevealCb(ents, obs){ ents.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); obs.unobserve(e.target); } }); }
  if('IntersectionObserver' in window && !reduce){
    // io      = early trigger (~45% up): the reading text, gallery, reviews, faq, banner.
    // ioLate  = late trigger (~65% up): the nutrition table — appears only after the reader has scrolled through the text.
    io=new IntersectionObserver(hmfRevealCb, {threshold:0, rootMargin:'0px 0px -45% 0px'});
    ioLate=new IntersectionObserver(hmfRevealCb, {threshold:0, rootMargin:'0px 0px -65% 0px'});
    ROOT.querySelectorAll('[data-reveal]').forEach(function(el){ io.observe(el); });
  } else {
    ROOT.querySelectorAll('[data-reveal]').forEach(function(el){ el.classList.add('in'); });
  }

  // ---- locale dropdowns (country/currency + language) ----
  ROOT.querySelectorAll('[data-loc]').forEach(function(wrap){
    var lbtn=wrap.querySelector('[data-loc-toggle]'), lmenu=wrap.querySelector('[data-loc-menu]');
    if(!lbtn||!lmenu) return;
    lbtn.addEventListener('click', function(e){
      e.stopPropagation();
      var willOpen = lmenu.hasAttribute('hidden');
      ROOT.querySelectorAll('[data-loc-menu]').forEach(function(m){ m.setAttribute('hidden',''); });
      ROOT.querySelectorAll('[data-loc-toggle]').forEach(function(b){ b.setAttribute('aria-expanded','false'); });
      if(willOpen){ lmenu.removeAttribute('hidden'); lbtn.setAttribute('aria-expanded','true'); }
    });
    lmenu.addEventListener('click', function(e){ e.stopPropagation(); });
  });
  document.addEventListener('click', function(){
    ROOT.querySelectorAll('[data-loc-menu]').forEach(function(m){ m.setAttribute('hidden',''); });
    ROOT.querySelectorAll('[data-loc-toggle]').forEach(function(b){ b.setAttribute('aria-expanded','false'); });
  });

  renderAll();
  probeMedia();
  refreshCart();
})();
